import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { DateFormat } from 'src/app/constants';
import { MngUserDataModel } from 'src/app/management/models/managementModel';
import { ManagementService } from 'src/app/management/services/management.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-mng',
  templateUrl: './header-mng.component.html',
  styleUrls: ['./header-mng.component.scss']
})
export class HeaderMngComponent implements OnInit, OnDestroy {

  @Input() isMngLoggedIn: boolean = false;

  destroySubscription = false;

  environment = environment;

  isMenuOpen = false;

  mngUser: MngUserDataModel;

  lastLoginDate: string;

  constructor(private managementService: ManagementService) {

  }

  ngOnInit(): void {
    this.mngUser = this.managementService.getMngUser();
    this.lastLoginDate = (this.mngUser && this.mngUser.last_login_utc) ? moment.utc(this.mngUser.last_login_utc).local().format(DateFormat.formatB) : 'Never';
  }

  goToHome() {
    this.managementService.goHome();
  }

  logout() {
    this.managementService.logout();
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!(event.target as HTMLElement).classList.contains('hamburger-icon')) {
      this.closeMenu();
    }
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }

}
